import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var ModBusSignal;
(function (ModBusSignal) {
    function getSignalsByDevice(signals, device) {
        return signals.filter((signal) => device.signals.includes(signal.id));
    }
    ModBusSignal.getSignalsByDevice = getSignalsByDevice;
    let Type;
    (function (Type) {
        Type[Type["DEFAULT"] = -1] = "DEFAULT";
        Type[Type["RESISTANCE_THERMOMETER"] = 1] = "RESISTANCE_THERMOMETER";
        Type[Type["THERMOCOUPLE"] = 2] = "THERMOCOUPLE";
        Type[Type["ONE_WIRE"] = 3] = "ONE_WIRE";
        Type[Type["THERMAL_SENSOR_FLOAT"] = 4] = "THERMAL_SENSOR_FLOAT";
        Type[Type["THERMAL_SENSOR_DIETRICH"] = 5] = "THERMAL_SENSOR_DIETRICH";
        Type[Type["UNIFIED_SIGNAL"] = 21] = "UNIFIED_SIGNAL";
        Type[Type["CONST_VOLTAGE_SIGNAL"] = 22] = "CONST_VOLTAGE_SIGNAL";
        Type[Type["DRY_CONTACT"] = 23] = "DRY_CONTACT";
        Type[Type["VALVE_POSITION"] = 24] = "VALVE_POSITION";
        Type[Type["DISCRETE_INPUT"] = 25] = "DISCRETE_INPUT";
        Type[Type["RESISTIVE_SENSOR"] = 26] = "RESISTIVE_SENSOR";
        Type[Type["ANALOG_INPUT"] = 27] = "ANALOG_INPUT";
        Type[Type["FLOAT32_PARAM"] = 28] = "FLOAT32_PARAM";
        Type[Type["INT16_PARAM"] = 29] = "INT16_PARAM";
        Type[Type["INT32_PARAM"] = 30] = "INT32_PARAM";
        Type[Type["FLOAT32_TYPE2_PARAM"] = 31] = "FLOAT32_TYPE2_PARAM";
        Type[Type["DISCRETE_OUTPUT"] = 41] = "DISCRETE_OUTPUT";
        Type[Type["ANALOG_OUTPUT_UINT16"] = 42] = "ANALOG_OUTPUT_UINT16";
        Type[Type["ANALOG_OUTPUT_UINT32"] = 43] = "ANALOG_OUTPUT_UINT32";
        Type[Type["ANALOG_OUTPUT_INT16"] = 44] = "ANALOG_OUTPUT_INT16";
        Type[Type["ANALOG_OUTPUT_INT32"] = 45] = "ANALOG_OUTPUT_INT32";
        Type[Type["ANALOG_OUTPUT_FLOAT"] = 46] = "ANALOG_OUTPUT_FLOAT";
    })(Type = ModBusSignal.Type || (ModBusSignal.Type = {}));
    let Flags;
    (function (Flags) {
        Flags[Flags["READABLE"] = 1] = "READABLE";
        Flags[Flags["WRITABLE"] = 2] = "WRITABLE";
    })(Flags = ModBusSignal.Flags || (ModBusSignal.Flags = {}));
    ModBusSignal.AnalogOutputTypes = [
        Type.ANALOG_OUTPUT_UINT16,
        Type.ANALOG_OUTPUT_UINT32,
        Type.ANALOG_OUTPUT_INT16,
        Type.ANALOG_OUTPUT_INT32,
        Type.ANALOG_OUTPUT_FLOAT,
    ];
    ModBusSignal.AnalogInputTypes = [
        Type.UNIFIED_SIGNAL,
        Type.CONST_VOLTAGE_SIGNAL,
        Type.DRY_CONTACT,
        Type.VALVE_POSITION,
        Type.DISCRETE_INPUT,
        Type.RESISTIVE_SENSOR,
        Type.ANALOG_INPUT,
        Type.FLOAT32_PARAM,
        Type.INT16_PARAM,
        Type.INT32_PARAM,
        Type.FLOAT32_TYPE2_PARAM,
    ];
    ModBusSignal.OutputActionTypes = [Type.DISCRETE_OUTPUT];
    ModBusSignal.WiredTemperatureSensorTypes = [
        Type.RESISTANCE_THERMOMETER,
        Type.THERMOCOUPLE,
        Type.ONE_WIRE,
        Type.THERMAL_SENSOR_FLOAT,
        Type.THERMAL_SENSOR_DIETRICH,
    ];
    ModBusSignal.translateModbusSignalType = {
        [Type.DEFAULT]: '',
        [Type.RESISTANCE_THERMOMETER]: 'Термометры сопротивления',
        [Type.THERMOCOUPLE]: 'Термопары',
        [Type.ONE_WIRE]: 'Термодатчики 1-wire',
        [Type.THERMAL_SENSOR_FLOAT]: 'Термодатчик float',
        [Type.THERMAL_SENSOR_DIETRICH]: 'Термодатчик Dietrich',
        [Type.UNIFIED_SIGNAL]: 'Унифицированные сигналы',
        [Type.CONST_VOLTAGE_SIGNAL]: 'Сигнал постоянного напряжения',
        [Type.DRY_CONTACT]: 'Датчик типа «сухой контакт»',
        [Type.VALVE_POSITION]: 'Датчики положения задвижек',
        [Type.DISCRETE_INPUT]: 'Дискретный вход',
        [Type.RESISTIVE_SENSOR]: 'Резистивный датчик',
        [Type.ANALOG_INPUT]: 'Аналоговый вход',
        [Type.FLOAT32_PARAM]: 'Параметр типа float32',
        [Type.INT16_PARAM]: 'Параметр типа int16',
        [Type.INT32_PARAM]: 'Параметр типа int32',
        [Type.FLOAT32_TYPE2_PARAM]: 'Параметр типа float32 (2)',
        [Type.DISCRETE_OUTPUT]: 'Дискретные выходы',
        [Type.ANALOG_OUTPUT_UINT16]: 'Аналоговые выходы uint16',
        [Type.ANALOG_OUTPUT_UINT32]: 'Аналоговые выходы uint32',
        [Type.ANALOG_OUTPUT_INT16]: 'Аналоговые выходы int16',
        [Type.ANALOG_OUTPUT_INT32]: 'Аналоговые выходы int32',
        [Type.ANALOG_OUTPUT_FLOAT]: 'Аналоговые выходы float',
    };
    let RegisterType;
    (function (RegisterType) {
        RegisterType[RegisterType["COIL"] = 0] = "COIL";
        RegisterType[RegisterType["DISCRETE_INPUT"] = 1] = "DISCRETE_INPUT";
        RegisterType[RegisterType["COIL_VARIANT_2"] = 2] = "COIL_VARIANT_2";
        RegisterType[RegisterType["INPUT_HOLDING_REGISTER"] = 3] = "INPUT_HOLDING_REGISTER";
        RegisterType[RegisterType["HOLDING_REGISTER"] = 4] = "HOLDING_REGISTER";
        RegisterType[RegisterType["OLD_FORMAT"] = 255] = "OLD_FORMAT";
    })(RegisterType = ModBusSignal.RegisterType || (ModBusSignal.RegisterType = {}));
    ModBusSignal.translateModbusRegisterType = {
        [RegisterType.COIL]: 'Coil (1/5)',
        [RegisterType.DISCRETE_INPUT]: 'Discrete Input (2)',
        [RegisterType.COIL_VARIANT_2]: 'Coil (1/15)',
        [RegisterType.INPUT_HOLDING_REGISTER]: 'Input/holding register (4/16)',
        [RegisterType.HOLDING_REGISTER]: 'Holding register (3/6)',
        [RegisterType.OLD_FORMAT]: 'Не выбрано',
    };
    function showDivisionCoefficient(modbus_signal) {
        return [
            Type.RESISTANCE_THERMOMETER,
            Type.THERMOCOUPLE,
            Type.ONE_WIRE,
            Type.THERMAL_SENSOR_FLOAT,
            Type.THERMAL_SENSOR_DIETRICH,
            Type.UNIFIED_SIGNAL,
            Type.CONST_VOLTAGE_SIGNAL,
            Type.DRY_CONTACT,
            Type.VALVE_POSITION,
            Type.DISCRETE_INPUT,
            Type.RESISTIVE_SENSOR,
            Type.ANALOG_INPUT,
            Type.FLOAT32_PARAM,
            Type.INT16_PARAM,
            Type.INT32_PARAM,
            Type.FLOAT32_TYPE2_PARAM,
        ].includes(modbus_signal.type);
    }
    ModBusSignal.showDivisionCoefficient = showDivisionCoefficient;
    ModBusSignal.default_object = {
        name: 'Регистр №',
        address: 0,
        buffer_length: 0,
        buffer_offset: 0,
        var_count: 1,
        var_length: 8,
        var_period_repeat: 8,
        setting_register: 1,
        type: -1,
        division_coefficient: 1,
        register_type: RegisterType.OLD_FORMAT,
    };
    ModBusSignal.get = createAccessors(arrayGetSet('modbus_signals'), ModBusSignal.default_object);
})(ModBusSignal || (ModBusSignal = {}));
